import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IEventParentCategoryState }  from 'Redux/Slices/EventParentCategory/EventParentCategorySlice';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const deleteEventParentCategoryRequest = (state: Draft<IEventParentCategoryState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const deleteEventParentCategorySuccess = (state: Draft<IEventParentCategoryState>, { type, payload }: PayloadAction<{
  id: string
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  const newEntries = { ...state.entries };
  if (payload.id in newEntries) {
    delete newEntries[payload.id];
  }
  state.maxCount = state.maxCount - 1;
  state.entries = newEntries;
};

export const deleteEventParentCategoryFailure = (state: Draft<IEventParentCategoryState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
